/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForCombineVo
 */
export interface OrderInfoForCombineVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    id?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    orderCode?: string;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    requestTypeName?: string;
    /**
     * 结算方式
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    paymentTypeName?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    warehouseName?: string;
    /**
     * 国际运输方式
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    internationalTransportMethodName?: string;
    /**
     * 接收人姓名
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    receiverName?: string;
    /**
     * 包裹数量
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    parcelCount?: number;
    /**
     * 包裹数量-入库数量
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    parcelWarehouseCount?: number;
    /**
     * 商品数量
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    goodsCount?: number;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    goodsTotalAmountCny?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 所有快递货位位置
     * @type {Array<string>}
     * @memberof OrderInfoForCombineVo
     */
    locations?: Array<string>;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    orderStatusName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof OrderInfoForCombineVo
     */
    updateTime?: string;
    /**
     * 包装后的纸箱数量
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    boxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    orderType?: number;
    /**
     * 返送订单 处理方式 1废弃， 2韩国库存， 3 韩国快递件， 4 橙火入仓 一般快递，5 橙火入仓 官方揽收快递， 6橙火入仓 官方揽收托盘
     * @type {number}
     * @memberof OrderInfoForCombineVo
     */
    returnFromCoupangMethod?: number;
    /**
     * 可合并到本订单的源订单列表
     * @type {Array<OrderInfoForCombineVo>}
     * @memberof OrderInfoForCombineVo
     */
    sourceOrders?: Array<OrderInfoForCombineVo>;
}

/**
 * Check if a given object implements the OrderInfoForCombineVo interface.
 */
export function instanceOfOrderInfoForCombineVo(value: object): value is OrderInfoForCombineVo {
    return true;
}

export function OrderInfoForCombineVoFromJSON(json: any): OrderInfoForCombineVo {
    return OrderInfoForCombineVoFromJSONTyped(json, false);
}

export function OrderInfoForCombineVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForCombineVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'paymentTypeName': json['paymentTypeName'] == null ? undefined : json['paymentTypeName'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'parcelCount': json['parcelCount'] == null ? undefined : json['parcelCount'],
        'parcelWarehouseCount': json['parcelWarehouseCount'] == null ? undefined : json['parcelWarehouseCount'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'goodsTotalAmountCny': json['goodsTotalAmountCny'] == null ? undefined : json['goodsTotalAmountCny'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'boxCount': json['boxCount'] == null ? undefined : json['boxCount'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'returnFromCoupangMethod': json['returnFromCoupangMethod'] == null ? undefined : json['returnFromCoupangMethod'],
        'sourceOrders': json['sourceOrders'] == null ? undefined : ((json['sourceOrders'] as Array<any>).map(OrderInfoForCombineVoFromJSON)),
    };
}

export function OrderInfoForCombineVoToJSON(json: any): OrderInfoForCombineVo {
    return OrderInfoForCombineVoToJSONTyped(json, false);
}

export function OrderInfoForCombineVoToJSONTyped(value?: OrderInfoForCombineVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderCode': value['orderCode'],
        'requestTypeName': value['requestTypeName'],
        'paymentTypeName': value['paymentTypeName'],
        'warehouseName': value['warehouseName'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'receiverName': value['receiverName'],
        'parcelCount': value['parcelCount'],
        'parcelWarehouseCount': value['parcelWarehouseCount'],
        'goodsCount': value['goodsCount'],
        'goodsTotalAmountCny': value['goodsTotalAmountCny'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'locations': value['locations'],
        'orderStatusName': value['orderStatusName'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'boxCount': value['boxCount'],
        'orderType': value['orderType'],
        'returnFromCoupangMethod': value['returnFromCoupangMethod'],
        'sourceOrders': value['sourceOrders'] == null ? undefined : ((value['sourceOrders'] as Array<any>).map(OrderInfoForCombineVoToJSON)),
    };
}

